import gql from 'graphql-tag';

export const getFacilityHistories = gql`
  query getFacilityHistories($id: String) {
    getFacilityHistories(id: $id) {
      updater
      updatedAt
    }
  }
`;
